import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'ngx-webstorage';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-document-emailer',
  templateUrl: './document-emailer.component.html',
  styleUrls: ['./document-emailer.component.css']
})
export default class DocumentEmailerComponent implements OnInit, OnChanges {

  public form!: FormGroup;
  @Input() data: any[] = [];
  public documents: any[] = [];

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private snackBar: MatSnackBar,
    private sessionSt: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      const documents = changes['data'].currentValue;
      this.documents = (documents || []).map((document: any) => ({
        id: document.key,
        title: document?.value?.name ?? '',
        url: document?.value?.file_path ?? '',
      }));
      if (this.form) {
        this.rebuildDocumentControls();
      }
    }
  }

  ngOnInit(): void {
    this.initForm();
    if (this.documents.length) {
      this.rebuildDocumentControls();
    }
  }

  public initForm(): void {
    const user = this.sessionSt.retrieve('userInfo') || {};
    const fullName = [user?.userinfo?.first_name, user?.userinfo?.last_name]
      .filter(Boolean)
      .join(' ')
      .trim();
    const email = user?.username ?? '';

    this.form = this.fb.group({
      name: [fullName, Validators.required],
      email: [email, [Validators.required, Validators.email]],
      documents: this.fb.array([]),
    });
  }

  private rebuildDocumentControls(): void {
    const ctrls = this.documents.map(() => this.fb.control(false));
    this.form.setControl('documents', this.fb.array(ctrls));
  }

  public onSubmit(): void{
    if(this.form.invalid){ 
      return;
    }

    const raw = this.form.getRawValue();
    const checks: boolean[] = raw.documents || [];
    const documents = checks
      .map((checked, i) =>
        checked && this.documents[i]?.url
          ? { title: this.documents[i].title, url: this.documents[i].url }
          : null
      )
      .filter((d): d is { title: string; url: string } => d != null);
    if (documents.length === 0) {
      this.snackBar.open('Select at least one document.', 'Close', { duration: 4000 });
      return;
    }
    this.sharedService
      .postAPI('amlin/email-documents', {
        name: raw.name,
        email: raw.email,
        documents,
      })
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.snackBar.open('Documents sent.', 'Close', { duration: 4000 });
          } else {
            this.snackBar.open(response.message || 'Failed to send email.', 'Close', {
              duration: 5000,
              panelClass: ['text-danger'],
            });
          }
        },
        error: (err) => {
          const msg = err?.error?.message || 'Failed to send email.';
          this.snackBar.open(msg, 'Close', { duration: 5000, panelClass: ['text-danger'] });
        },
      });
  }

}
